/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { Checklist, ChecklistFromJSON, ChecklistFromJSONTyped, ChecklistToJSON } from "./Checklist";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";

/**
 *
 * @export
 * @interface ChecklistControllerResponse
 */
export interface ChecklistControllerResponse {
  /**
   *
   * @type {Checklist}
   * @memberof ChecklistControllerResponse
   */
  data?: Checklist;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ChecklistControllerResponse
   */
  error?: ErrorResponse;
}

export function ChecklistControllerResponseFromJSON(json: any): ChecklistControllerResponse {
  return ChecklistControllerResponseFromJSONTyped(json, false);
}

export function ChecklistControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChecklistControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : ChecklistFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ChecklistControllerResponseToJSON(value?: ChecklistControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: ChecklistToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
